import { render, staticRenderFns } from "./TemplateDocumentCard.vue?vue&type=template&id=16ebd2e8&scoped=true"
import script from "./TemplateDocumentCard.vue?vue&type=script&lang=js"
export * from "./TemplateDocumentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ebd2e8",
  null
  
)

export default component.exports